import * as React from 'react';
export default function SvgUfo() {
  return /*#__PURE__*/React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.855 10.408c-1.505 1.19-2.327 2.565-2.053 3.742.478 2.044 4.087 2.71 8.063 1.489 3.975-1.222 6.81-3.87 6.333-5.914-.24-1.03-1.274-1.71-2.749-1.975l-.5-.09M16.75 17.75l1.5 1.5M13.75 18.75l.5.5M18.75 15.75l.5.5",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5 4.9l-.525.143c-2.32.628-3.697 3.036-3.076 5.379l.144.54c.173.655.671 1.177 1.346 1.245.835.084 2.115.082 3.678-.341 1.572-.426 2.684-1.074 3.365-1.57.545-.395.714-1.09.541-1.741l-.145-.549c-.622-2.343-3.007-3.733-5.328-3.105z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}